<div class="form-container">
  <form method="post" @submit.prevent="resetPassword">
    <div class="text-center mb-3">
      <p class="text-dark fw-bold text-md">Reset Your Password</p>
      <p class="text-xs text-secondary">Please create a new password for your first login</p>
    </div>
    
    <!-- Email Input (readonly) -->
    <div class="form-group">
      <div class="form-floating">
        <input
          type="text"
          class="form-control-nb bottom-border-input text-xs"
          placeholder=" "
          v-model="email"
          name="email"
          id="email-input"
          readonly
        />
        <label for="email-input" class="fw-bold text-xs">Email</label>
      </div>
    </div>

    <!-- Current Password Input -->
    <div class="form-group">
      <div class="form-floating position-relative">
        <input
          class="form-control-nb bottom-border-input text-xs pr-5"
          placeholder=" "
          v-model="old_password"
          name="old_password"
          :type="show_old_password ? 'text' : 'password'"
          id="old-password-input"
        />
        <label for="old-password-input" class="fw-bold text-xs">Current Password</label>
        <span
          class="eye-icon"
          @click="toggle_old_password_view"
        >
          <i :class="show_old_password ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
      <small class="text-danger p-2 text-xxs fw-bold d-none old-password-message"
        >Please fill in this field</small>
    </div>

    <!-- New Password Input -->
    <div class="form-group">
      <div class="form-floating position-relative">
        <input
          class="form-control-nb bottom-border-input text-xs pr-5"
          placeholder=" "
          v-model="new_password"
          name="new_password"
          :type="show_new_password ? 'text' : 'password'"
          id="new-password-input"
        />
        <label for="new-password-input" class="fw-bold text-xs">New Password</label>
        <span
          class="eye-icon"
          @click="toggle_new_password_view"
        >
          <i :class="show_new_password ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
      <small class="text-danger p-2 text-xxs fw-bold d-none new-password-message"
        >Please fill in this field</small>
      <small class="text-secondary p-2 text-xxs">Password must be at least 8 characters long</small>
    </div>

    <!-- Confirm Password Input -->
    <div class="form-group">
      <div class="form-floating position-relative">
        <input
          class="form-control-nb bottom-border-input text-xs pr-5"
          placeholder=" "
          v-model="confirm_password"
          name="confirm_password"
          :type="show_confirm_password ? 'text' : 'password'"
          id="confirm-password-input"
        />
        <label for="confirm-password-input" class="fw-bold text-xs">Confirm New Password</label>
        <span
          class="eye-icon"
          @click="toggle_confirm_password_view"
        >
          <i :class="show_confirm_password ? 'fa fa-eye-slash' : 'fa fa-eye'"></i>
        </span>
      </div>
      <small class="text-danger p-2 text-xxs fw-bold d-none confirm-password-message"
        >Please fill in this field</small>
    </div>

    <div v-if="client === 'suzuki'" class="text-center text-xs fw-bold">
      Powered by <a href="http://www.mobiafrica.co.za" class="suzuki-link">www.mobiafrica.co.za</a>
    </div>

    <small class="text-danger p-2 text-xxs fw-bold d-none reset-message"></small>
    <div class="mb-3">
      <button
        type="submit"
        class="btn btn-bg-green secondary-text-dark text-xs w-75 fw-bold mt-2"
      >
        Reset Password
      </button>
    </div>

    <div class="mt-1 text-center">
      <span class="text-dark text-xs fw-bold">Need help?</span>
      <a class="text-primary text-xs" @click="open_modal">
        Contact support
      </a>
    </div>
  </form>
</div>

<!-- Bootstrap Modal -->
<div class="modal fade" id="reset-modal" tabindex="-1" aria-labelledby="reset-modal-label" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content rounded-3 shadow border">
      <div class="modal-header">
        <h5 class="modal-title" id="reset-modal-label">Need Help?</h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
      </div>
      <div class="modal-body">
        <p class="mb-3 text-xs text-dark">
          If you're having trouble resetting your password, please contact support.
        </p>
        <p class="fw-bold mb-1">Contact Us:</p>
        <p class="mb-0 text-xs">
          Email us at
          <a href="mailto:support@tgpdc.com" class="text-decoration-none">
            support@tgpdc.com
          </a>
        </p>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-bg-green text-xs"
          data-bs-dismiss="modal"
        >
          Close
        </button>
      </div>
    </div>
  </div>
</div>
